/* eslint-disable no-trailing-spaces */
/* eslint no-console: ["error", { allow: ["warn", "error", "info"] }] */
/* eslint no-invalid-this: 0 */
/* eslint max-len: 0 */

import * as Api from './api';

const NS = 'giftRegistry';
const $loadingSpinner = $('.loading-spinner');

export function add($pg, endpoint, param, addedCB) {
    // console.log(`${NS}.add`, endpoint, param);

    if (!endpoint) {
        console.warn(`${NS}.add. Please supply endpoint variable. Returned early;`);
        return;
    }

    if (!$pg) {
        console.warn(`${NS}.add. Please supply $pg variable. Returned early;`);
        return;
    }

    // toggle spinners, remove errors
    $pg.find('.error-messages').removeClass('is-active').text('');
    $loadingSpinner.addClass('is-active');
    let apiParam = {
        id: param.id,
        quantity: param.quantity,
    };

    addToGiftRegistryCall(endpoint, apiParam).then((response) => {
        if (response && response.result === 'SUCCESS') {
            if (addedCB) addedCB(response);
        } else {
            // show error div
            $pg.find('.error-messages').addClass('is-active').text(response.message);
        }

        $loadingSpinner.removeClass('is-active');
    });

    function addToGiftRegistryCall(endpoint, $data) {
        return Api.callApi(endpoint, $data);
    }
}

export function remove($pg, endpoint, param, removedCB) {
    // console.log(`${NS}.add`, endpoint, param);

    if (!endpoint) {
        console.warn(`${NS}.add. Please supply endpoint variable. Returned early;`);
        return;
    }

    if (!$pg) {
        console.warn(`${NS}.add. Please supply $pg variable. Returned early;`);
        return;
    }

    // toggle spinners, remove errors
    $pg.find('.error-messages').removeClass('is-active').text('');
    $loadingSpinner.addClass('is-active');

    removeGiftRegistryCall(endpoint, param).then((response) => {
        if (response && response.result === 'SUCCESS') {
            if (removedCB) removedCB(response);
        } else {
            // show error div
            $pg.find('.error-messages').addClass('is-active').text(response.message);
        }

        $loadingSpinner.removeClass('is-active');
    });

    function removeGiftRegistryCall(endpoint, $data) {
        return Api.callApi(endpoint, $data);
    }
}



// WEBPACK FOOTER //
// ./giftRegistry.js